import React from 'react';
import { ProfileData } from './types';

interface ProfileTabProps {
  profileData: ProfileData[];
}

const ProfileTab: React.FC<ProfileTabProps> = ({ profileData }) => (
  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 16 }}>
    <tbody>
      {profileData.map((row, index) => (
        <tr key={row.label} style={{
          borderBottom: index < profileData.length - 1 ? '1px solid #eee' : 'none'
        }}>
          <td style={{ color: '#666', padding: '20px 0', width: 140 }}>{row.label}</td>
          <td style={{ color: '#222', padding: '20px 0', fontFamily: 'monospace' }}>{row.value}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default ProfileTab;
